module.exports = __webpack_public_path__ + "img/3ca48fbe89bfd475e7a0e6c34304759.f20ffb1f.jpg";